import React, { ReactNode } from 'react';
import classNames from 'classnames';
import useStyles from '../../assets/jss/material-dashboard-pro-react/components/cardFooterStyleTS';

interface ICardFooterProps {
	className?: string;
	children?: ReactNode;
	plain?: string;
	profile?: string;
	pricing?: string;
	testimonial?: string;
	stats?: boolean;
	chart?: string;
	product?: string;
}

export default function CardFooter(props: ICardFooterProps) {
	const classes = useStyles();
	const { className, children, plain, profile, pricing, testimonial, stats, chart, product, ...rest } = props;
	const cardFooterClasses = classNames({
		[classes.cardFooter]: true,
		[classes.cardFooterPlain]: plain,
		[classes.cardFooterProfile]: profile || testimonial,
		[classes.cardFooterPricing]: pricing,
		[classes.cardFooterTestimonial]: testimonial,
		[classes.cardFooterStats]: stats,
		[classes.cardFooterChart]: chart || product,
		[className]: className !== undefined,
	});
	return (
		<div className={cardFooterClasses} {...rest}>
			{children}
		</div>
	);
}
